import { render, staticRenderFns } from "./Func51Listagem.vue?vue&type=template&id=57fca63d"
import script from "./Func51Listagem.vue?vue&type=script&lang=js"
export * from "./Func51Listagem.vue?vue&type=script&lang=js"
import style0 from "./Func51Listagem.vue?vue&type=style&index=0&id=57fca63d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports